{
  "error.cookie_needed.description": "您的瀏覽器被設定為封鎖Cookie和本機儲存區。\n請允許瀏覽器偏好設定中的Cookie存取Experience Cloud。",
  "error.cookie_needed.heading": "Cookie已封鎖",
  "error.cookie_needed.refreshBtn": "重新整理",
  "error.not_found.description": "此頁面無法使用，請檢查 URL 或造訪其他頁面。",
  "error.not_found.heading": "錯誤 404: 找不到頁面",
  "error.offline.description": "檢查您的網際網路連線並重新整理頁面",
  "error.offline.heading": "無網際網路連線",
  "error.rate_limit.description": "目前的訪客人數眾多，請重新載入頁面，或稍候幾分鐘後再試。\n若畫面持續顯示這則訊息，請聯絡客服人員並提供:\nEIM 執行個體 ID {instanceId}",
  "error.rate_limit.heading": "錯誤 429: 分級限制",
  "error.rate_limit.refreshBtn": "重新整理",
  "error.timeout.description": "無法載入此頁面，請嘗試重新整理或造訪其他頁面。\n若畫面持續顯示這則訊息，請聯絡客服人員並提供:\nEIM 執行個體 ID {instanceId}",
  "error.timeout.heading": "錯誤 408: 要求逾時",
  "error.timeout.refreshBtn": "重新整理",
  "error.unknown.description": "頁面未順利載入。請檢查您的登入資料，並再試一次。\n若畫面持續顯示這則訊息，請聯絡客服人員並提供:\nEIM 執行個體 ID {instanceId}",
  "error.unknown.heading": "頁面載入失敗",
  "error.unknown.refreshBtn": "重新整理"
}
